import Browser, { Parser } from 'bowser'

const supportedRestrictions = {
  safari: '>12.1',
  chrome: '>70',
}

const checkBrowser = (restrictions: Parser.checkTree) => {
  try {
    const browser = Browser.getParser(window.navigator.userAgent)
    return browser.satisfies(restrictions)
    // returns 'true' if current browser satisfies restrictions, 'false' if it does not satisfy restrictions
    // and 'undefined' if current browser is not listed in restrictions
  } catch (error) {
    return false
  }
}

export const getIsSupportedAndUpdatedBrowser = () =>
  Boolean(checkBrowser(supportedRestrictions))

export const getIsOutdatedBrowser = () =>
  checkBrowser(supportedRestrictions) === false

export const getBrowserName = () => {
  try {
    const browser = Browser.getParser(window.navigator.userAgent)
    return browser.getBrowserName()
  } catch (error) {
    return 'Browser'
  }
}

export const getBrowserVersion = () => {
  try {
    const browser = Browser.getParser(window.navigator.userAgent)
    return browser.getBrowserVersion()
  } catch (error) {
    return '1'
  }
}

export const getOSName = () => {
  try {
    const browser = Browser.getParser(window.navigator.userAgent)
    return browser.getOSName()
  } catch (error) {
    return 'OS'
  }
}

export const isIPad = (): boolean => navigator.userAgent.match(/iPad/i) != null
export const isWindows = (): boolean =>
  navigator.userAgent.match(/Windows/i) != null

export const getDeviceType = (): string =>
  isWindows() ? 'windows' : isIPad() ? 'ipad' : 'mac'

export const getIsScrollSmoothSupported = () => {
  const browserName = getBrowserName()
  const browserVersion = getBrowserVersion()

  // Reasoning: https://bugs.webkit.org/show_bug.cgi?id=238497
  // There is bug with smooth scroll behavior in Safari 15.4
  const isSafari15OrHigher =
    browserName === 'Safari' && Number(browserVersion) >= 15.4

  // also it doesn't work on some versions of chrome for some reason
  const isChrome = browserName === 'Chrome'

  return !isSafari15OrHigher && !isChrome
}
